import React from "react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Podcasts,
  NotificationsActive,
  Assessment,
  Dashboard,
  Group,
  Campaign,
  Security,
} from "@mui/icons-material";
import theme from "../../../theme";
import { useNavigate } from "react-router-dom";
import { useSelector } from "../../../store";
import checkRole, { UserRoles } from "../../../helpers/checkRole";

interface Props {
  handleClose: () => void;
}

const MenuView: React.FC<Props> = (props) => {
  const { handleClose } = props;
  const navigate = useNavigate();

  const { loggedInUser } = useSelector((store) => store.auth);

  const menuItems = [
    {
      label: "Dashboard",
      icon: <Dashboard />,
      function: () => navigate(`/dashboard`),
      authorized: true,
    },
    {
      label: "Connections",
      icon: <Podcasts />,
      function: () => navigate("/connections"),
      authorized: checkRole(loggedInUser!, UserRoles.AnyAdmin),
    },
    {
      label: "Notifications",
      icon: <Campaign />,
      function: () => navigate("/notifications"),
      authorized: checkRole(loggedInUser!, UserRoles.AnyAdmin),
    },
    {
      label: "Alerts",
      icon: <NotificationsActive />,
      function: () => navigate("/alerts"),
      authorized: true,
    },
    {
      label: "Reports",
      icon: <Assessment />,
      function: () => navigate("/reports"),
      authorized: checkRole(loggedInUser!, UserRoles.AnyAdmin),
    },
    {
      label: "Users",
      icon: <Group />,
      function: () => navigate("/users"),
      authorized: checkRole(loggedInUser!, UserRoles.AnyAdmin),
    },
  ];

  return (
    <Box width={250} display="flex" role="presentation" onClick={handleClose}>
      <List sx={{ width: "100%" }}>
        {menuItems
          .filter((x) => !!x.authorized)
          .map((item) => (
            <Box key={item.label}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={item.function}
                  sx={{
                    "&:hover, &:focus": {
                      "& svg:first-of-type": {
                        transition: "0.5s",
                        transform: "rotate(-180deg)",
                      },
                    },
                  }}
                >
                  <ListItemIcon sx={{ paddingX: 2 }}>
                    <Avatar
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        width: "35px",
                        height: "35px",
                        color: "#fff",
                      }}
                    >
                      <IconButton color="inherit">{item.icon}</IconButton>
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontSize: 16,
                      fontWeight: "light",
                      color: "primary",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </Box>
          ))}
        {checkRole(loggedInUser!, UserRoles.GlobalAdmin) && (
          <>
            <Divider sx={{ margin: 1 }} />
            <Box>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() =>
                    (window.location.href = `${process.env.REACT_APP_AUTH_URL}`)
                  }
                  sx={{
                    "&:hover, &:focus": {
                      "& svg:first-of-type": {
                        transition: "0.5s",
                        transform: "rotate(-180deg)",
                      },
                    },
                  }}
                >
                  <ListItemIcon sx={{ paddingX: 2 }}>
                    <Avatar
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        width: "35px",
                        height: "35px",
                        color: "#fff",
                      }}
                    >
                      <IconButton color="inherit">
                        <Security />
                      </IconButton>
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText
                    primary="Admin Portal"
                    primaryTypographyProps={{
                      fontSize: 16,
                      fontWeight: "light",
                      color: "primary",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </Box>
          </>
        )}
      </List>
    </Box>
  );
};

export default MenuView;
